export default __webpack_public_path__ + "static/media/mic.a315f405.svg";